import actions from './actions';
import { fetchAndConstructPodcastObject } from '../../../modules/AnchorAPI/fetchCurrentUsersPodcast';

const { setPodcastDataFetchStatus, setPodcast } = actions;

const fetchPodcastAndSet = () => dispatch => {
  dispatch(setPodcastDataFetchStatus('loading'));
  return fetchAndConstructPodcastObject()
    .then(podcast => {
      dispatch(setPodcast(podcast));
      dispatch(setPodcastDataFetchStatus('success'));
    })
    .catch(() => dispatch(setPodcastDataFetchStatus('error')));
};

const getIsOptedOutOfDistributionFromPodcastStatus = podcastStatus => {
  const isOptedOutFromDatabase = podcastStatus === 'optedout';
  return isOptedOutFromDatabase;
};

export default {
  fetchPodcastAndSet,
  getIsOptedOutOfDistributionFromPodcastStatus,
};
